import { actionTypes } from "../actions/coupon";

let coupons = JSON.parse(localStorage.getItem('coupons'))

const initialState = {
    coupons: null,
    stores: null,
    users: null
}

const CouponsReducer = (state = coupons || initialState, action) => {
  let newState = state;
  switch (action.type) {
    case actionTypes.GET_STORE_SEARCH: {
      newState = {
        ...state,
        stores: action.payload,
      };
      break;
    }
    case actionTypes.GET_USER_SEARCH: {
      newState = {
        ...state,
        users: action.payload,
      };
      break;
    }
    default: {
      newState = state;
      break;
    }
  }
  if (newState) {
    localStorage.setItem('coupons', JSON.stringify(newState));
  } else {
    localStorage.removeItem('coupons')
  }
  return newState
};

export default CouponsReducer;
